import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-shipping',
  templateUrl: './shipping.component.html',
  styleUrls: ['./shipping.component.scss']
})
export class ShippingComponent implements OnInit {

  constructor(private title: Title) { }

  ngOnInit(): void {
    // this.title.setTitle(`Shipping Policy | Illusbook`);
  }

}
